import LeaveTable from "@/components/leave/LeaveTable";
import { connect } from "react-redux";
import { Actions as EMPLOYEEACTIONS } from "@/store/actions/employeeActions";
import { Actions as LEAVEACTIONS } from "@/store/actions/leaveActions";
import { format, addMonths } from "date-fns";
import { useEffect } from "react";
import { PlusCircleIcon } from "@heroicons/react/20/solid";
import InvalidPermissions from "../company-pages/InvalidPermissions";

const EmployeeLeave = ({ employeesGetListWithSalary, employees, userPermissions, setOpenModal, agreementId }) => {
	useEffect(() => {
		if (employees?.length > 0) return;
		employeesGetListWithSalary();
	}, []);

	if (userPermissions == "None") return <InvalidPermissions />;
	if (!employees) return null;
	return (
		<>
			<div className="col-xs-12 content mb-5">
				{userPermissions != "Read" && (
					<>
						<div
							className="btn btn-success pull-right"
							style={{ marginLeft: 10 }}
							onClick={() => setOpenModal(true, { agreement: agreementId, location: "employeeLeave" })}
						>
							<PlusCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
							<div style={{ float: "left" }}> Add Leave Application </div>
						</div>
					</>
				)}
			</div>
			<LeaveTable location="employeeLeave" />
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		employees: state.employees.employeeListWithSalary,
		userPermissions: state?.permissions?.my?.permissions?.leave,
		agreementId: state.employee?.employeeDetails?.id,
	};
};

const mapDispatchToProps = (dispatch) => ({
	employeesGetListWithSalary: () =>
		dispatch(
			EMPLOYEEACTIONS.employeesGetListWithSalary(
				{
					from:
						format(addMonths(new Date(), -2), "yyyy") == format(new Date(), "yyyy")
							? format(new Date(), "yyyy-01-01")
							: format(addMonths(new Date(), -2), "yyyy-MM-01"), // get list from 2 months prior to start of year
					to: format(new Date(), "yyyy-12-31"),
				},
				{ includeTax: true },
			),
		),
	setOpenModal: (status, leave) => dispatch(LEAVEACTIONS.setOpenModal(status, leave, true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeLeave);
